<template>
  <div
    v-if="closedoption"
    class="row wrapper border-bottom white-bg page-heading"
  >
    <div class="col-lg-11">
      <ol v-if="previousPage == 'reviewlist'" class="breadcrumb p-1 px-3 mb-0">
        <li class="breadcrumb-item">
          <a @click="formdesigner()">{{ $t("navigations.design form") }}</a>
        </li>
        <li class="breadcrumb-item">
          <strong>{{ $t("navigations.view form") }}</strong>
        </li>
      </ol>
    </div>
    <div class="col-lg-1 text-end align-self-center">
      <a class="tooltip-wrapper pointer" style="float:right">
        <i class="fa fa-times" @click="gotopage()"></i>
        <span class="custom-tooltip closetooltipposition">Close</span>
      </a>
    </div>
  </div>

  <div class="wrapper wrapper-content annotated-wrapper">
    <div v-if="annotatedTemplate" class="annotated-document">
      <section
        v-for="page in annotatedPages"
        :key="page.pageNo"
        class="annotated-page"
      >
        <header class="annotated-title">
          ANNOTATED eCRF - {{ annotatedTemplate.formname || annotatedTemplate.templateName || formName }}
          <span v-if="annotatedDomain">({{ annotatedDomain }})</span>
        </header>

        <div class="annotated-subtitle">
          <span>Version: {{ annotatedTemplate.version || "-" }}</span>
          <span>Language: {{ annotatedTemplate.language || "-" }}</span>
          <span v-if="annotatedTemplate.cdashVersion">CDASH v{{ annotatedTemplate.cdashVersion }}</span>
          <span v-if="annotatedTemplate.sdtmVersion">SDTM v{{ annotatedTemplate.sdtmVersion }}</span>
        </div>

        <div class="annotation-legend">
          <div class="legend-title">ANNOTATION LEGEND:</div>
          <div class="legend-items">
            <span><b>DB</b> = SDTM Domain</span>
            <span><b>CDASH</b> = CDASH Variable Name</span>
            <span><b>OID</b> = Item OID</span>
            <span><b class="required-star">*</b> = Required Field</span>
          </div>
        </div>

        <template
          v-for="section in annotatedSections(page)"
          :key="`${page.pageNo}-${section.title}`"
        >
          <div v-if="section.title" class="annotated-section-title">
            {{ section.title }}
          </div>

          <table class="annotated-table">
            <thead>
              <tr>
                <th>Question / Item</th>
                <th>Response / Input</th>
                <th>Annotation</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="field in section.fields"
                :key="`${page.pageNo}-${field.fieldName}`"
              >
                <td class="question-cell">
                  <div class="question-label">{{ field.label || field.fieldName }}</div>
                  <div v-if="isRequiredField(field)" class="required-note">
                    * Required
                  </div>
                </td>
                <td class="response-cell">
                  <template v-if="hasOptions(field)">
                    <div
                      v-for="option in field.options"
                      :key="`${field.fieldName}-${option.codevalue}-${option.optionname}`"
                      class="choice-row"
                    >
                      <span class="choice-mark">{{ field.type == "checkbox" ? "□" : "○" }}</span>
                      <span>{{ formatOption(option) }}</span>
                    </div>
                  </template>
                  <template v-else-if="field.type == 'date'">
                    <span class="response-hint">DD-MMM-YYYY</span>
                    <div class="response-line"></div>
                  </template>
                  <template v-else-if="field.type == 'textarea' || field.type == 'summary' || field.type == 'notes'">
                    <div class="response-line long"></div>
                    <div class="response-line long"></div>
                  </template>
                  <template v-else-if="field.type == 'grid'">
                    <span class="response-hint">Table response</span>
                  </template>
                  <template v-else>
                    <span class="response-hint">{{ inputHint(field) }}</span>
                    <div class="response-line"></div>
                  </template>
                </td>
                <td class="annotation-cell">
                  <div><b>DB:</b> {{ annotationDb(field) }}</div>
                  <div><b>CDASH:</b> {{ annotationCdash(field) }}</div>
                  <div><b>OID:</b> {{ annotationOid(field) }}</div>
                  <div v-if="field.codelist_OID">
                    <b>Codelist:</b> {{ field.codelist_OID }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>

        <footer class="annotated-footer">
          Page {{ page.pageNo }} of {{ annotatedPages.length }}
        </footer>
      </section>
    </div>

    <div v-else class="annotated-empty">
      Loading annotated form...
    </div>
  </div>
</template>

<script src="./viewAnotatedForm.js"></script>

<style scoped>
.annotated-wrapper {
  background: #eef1f5;
  margin-left: 15px;
  min-height: 100vh;
  padding: 24px 0;
}

.annotated-document {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.annotated-page {
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.18);
  color: #1f2933;
  margin: 0 auto;
  min-height: 1122px;
  padding: 40px 56px;
  width: 794px;
}

.annotated-title {
  background: #1a3c5e;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  padding: 8px 12px;
  text-align: center;
}

.annotated-subtitle {
  background: #10284a;
  color: #bdd7ee;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  gap: 14px;
  justify-content: center;
  padding: 8px 12px;
}

.annotation-legend {
  background: #eef6ff;
  border: 1px solid #2e6d9f;
  display: grid;
  grid-template-columns: 150px 1fr;
  margin: 18px 0;
  padding: 10px;
}

.legend-title {
  color: #1a3c5e;
  font-size: 12px;
  font-weight: 700;
}

.legend-items {
  display: flex;
  flex-wrap: wrap;
  font-size: 11px;
  gap: 10px 18px;
}

.required-star,
.required-note {
  color: #b00000;
}

.annotated-section-title {
  background: #2e6d9f;
  border: 1px solid #1a3c5e;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-top: 16px;
  padding: 7px 10px;
}

.annotated-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.annotated-table th {
  background: #d6e8f7;
  border: 1px solid #2e6d9f;
  color: #1a3c5e;
  font-size: 12px;
  padding: 7px 8px;
  text-align: left;
}

.annotated-table th:nth-child(1),
.question-cell {
  width: 38%;
}

.annotated-table th:nth-child(2),
.response-cell {
  width: 37%;
}

.annotated-table th:nth-child(3),
.annotation-cell {
  width: 25%;
}

.annotated-table td {
  border: 1px solid #cbd5df;
  font-size: 12px;
  min-height: 58px;
  padding: 10px 8px;
  vertical-align: top;
}

.annotated-table tbody tr:nth-child(odd) .question-cell,
.annotated-table tbody tr:nth-child(odd) .response-cell {
  background: #f5faff;
}

.annotation-cell {
  background: #fff8dc;
  color: #5b3000;
  font-size: 11px;
  line-height: 1.55;
}

.question-label {
  color: #1a3c5e;
  font-weight: 700;
  line-height: 1.35;
}

.required-note {
  font-size: 10px;
  margin-top: 8px;
}

.response-cell {
  color: #1a3c5e;
}

.response-hint {
  color: #8a8f98;
  display: inline-block;
  font-size: 11px;
  margin-bottom: 4px;
}

.response-line {
  border-bottom: 1px solid #1a3c5e;
  height: 14px;
  width: 80%;
}

.response-line.long {
  margin-bottom: 10px;
  width: 92%;
}

.choice-row {
  align-items: flex-start;
  display: flex;
  gap: 6px;
  line-height: 1.35;
  margin-bottom: 6px;
}

.choice-mark {
  color: #1a3c5e;
  flex: 0 0 auto;
  font-size: 12px;
  line-height: 1.2;
}

.annotated-footer {
  color: #5f6b7a;
  font-size: 11px;
  margin-top: 24px;
  text-align: right;
}

.annotated-empty {
  background: #ffffff;
  border: 1px solid #d6dee7;
  margin: 0 auto;
  padding: 24px;
  text-align: center;
  width: 794px;
}

@media print {
  .page-heading {
    display: none;
  }

  .annotated-wrapper {
    background: #ffffff;
    margin-left: 0;
    padding: 0;
  }

  .annotated-page {
    box-shadow: none;
    min-height: 0;
    page-break-after: always;
    width: auto;
  }
}
</style>
